import React from "react";
import "../../../plans.scss";

export default function EnterprisePlan() {
  return (
    <div className="col s4 m4 l4 Enterprise">
      <div className="plan-card">
        <div className="tag-price">
          <h3>Enterprise</h3>
          <div className="row price-box">
            <div className="col s12 m12 l12">
              {" "}
              <p>
                Intelligent features that keep your design work safe and secure.
              </p>
            </div>
          </div>
        </div>
        <p style={{ fontWeight: "500", color: "#989898" }}>
          Everything in Pro +
        </p>

        <ul>
          <li>Complete Data Privacy </li>
          <li>SSO + advanced security</li>
          <li>Custom ML Integration</li>
          <li>Centralized IT deployment tools</li>
          <li>User authentication with Vizcom ID</li>
          <li>1:1 support sessions with product experts</li>
        </ul>

        <div className="row buttons">
          <div className="col s12 m12  l12 "></div>
        </div>
      </div>
    </div>
  );
}
